import { useState, useMemo } from 'react';
import { createSafeContext } from '@mews/framework';
import { WithChildren } from '@optimus-web/common';
import { SimpleInvoice } from '@mews-commander/data-access';
import { primitiveTypeUniq } from '@mews/fp';

interface InvoicesContextType {
    selectedInvoices: SimpleInvoice[];
    setSelectedInvoices: React.Dispatch<React.SetStateAction<SimpleInvoice[]>>;
    ownerIds: string[];
    invoiceIds: string[];
    ownerEmails: string[];
}

const { CityLedgerMultipleInvoicesContextProvider, useCityLedgerMultipleInvoicesContext } = createSafeContext<
    'CityLedgerMultipleInvoicesContext',
    InvoicesContextType
>('CityLedgerMultipleInvoicesContext');

export const CityLedgerInvoicesProvider: React.FC<WithChildren> = ({ children }) => {
    const [selectedInvoices, setSelectedInvoices] = useState<SimpleInvoice[]>([]);

    const value = useMemo(() => {
        const ownerIds = primitiveTypeUniq(selectedInvoices.map((invoice) => invoice.ownerId));
        const ownerEmails = primitiveTypeUniq(selectedInvoices.map((invoice) => invoice.ownerEmail)).filter(
            (e) => e != null
        );
        const invoiceIds = selectedInvoices.map((invoice) => invoice.invoiceId);

        return { selectedInvoices, setSelectedInvoices, ownerIds, invoiceIds, ownerEmails };
    }, [selectedInvoices]);

    return (
        <CityLedgerMultipleInvoicesContextProvider value={value}>{children}</CityLedgerMultipleInvoicesContextProvider>
    );
};

export { useCityLedgerMultipleInvoicesContext };
